module.exports = "./img/5939336c2a9ef7674a3a593cf48aab93.jpg";